@if (isLoading) {
  <div class="lb-loading">
    <mat-spinner></mat-spinner>
  </div>
} @else {
  @if (!isLoading) {
    <mat-tab-group>
      @if (showOrg) {
        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon class="tab-icon">domain</mat-icon>
            My Org
          </ng-template>
          <app-org-leaderboard [dashboardLbType]="dashboardLbType" [InitialData]="" ></app-org-leaderboard>
        </mat-tab>
      }
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">public</mat-icon>
          Global
        </ng-template>
        <app-global-leaderboard [dashboardLbType]="dashboardLbType"></app-global-leaderboard>
      </mat-tab>
    </mat-tab-group>
  }
}
